import React from "react";
import { connect } from "react-redux";

import {
  Box,
  Avatar,
  IconButton,
  LinearProgress,
  Button
} from "@mui/material";

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import { IInspectionPanelListItem } from "./inspection-panel-list-item-props.interface";
import plateAction from "../../../../../../../redux/actions/plateAction";
import uniqueInspectionIDAction from "../../../../../../../redux/actions/uniqueInspectionIDAction";
import { useHistory } from "react-router-dom";
import appletProfileIdAction from "../../../../../../../redux/actions/appletProfileIdAction";
import vehicleDataAction from "../../../../../../../redux/actions/vehicleDataAction";

const InspectionPanelListItem = (props: IInspectionPanelListItem) => {
  const {
    atualUploadId,
    editable,
    finished,
    incomplete,
    inspectionSteps,
    openDeleteDialog,
    hasError,
  } = props;

  const history = useHistory();

  const isUploading = atualUploadId
    && (atualUploadId === inspectionSteps[0].uniqueIdentifier);
  
  const goToEdit = () => {
    // @ts-ignore
    props.plateAction(inspectionSteps[0].plate);
    // @ts-ignore
    props.uniqueInspectionIDAction(inspectionSteps[0].uniqueIdentifier);
    // @ts-ignore
    props.appletProfileIdAction(inspectionSteps[0].appletProfileId);

    history.push('summary');
  }

  const continueInspection = () => {
    // @ts-ignore
    props.plateAction(inspectionSteps[0].plate);
    // @ts-ignore
    props.uniqueInspectionIDAction(inspectionSteps[0].uniqueIdentifier);
    // @ts-ignore
    props.appletProfileIdAction(inspectionSteps[0].appletProfileId);
    // @ts-ignore
    props.vehicleDataAction(inspectionSteps[0].vehicleData);

    history.push('/inspection?resume=1');
  }

  const openVehicleError = () => {
    document.dispatchEvent(new Event('vehicleTypeError'));
  }

  return (
    <Box
      className="list-item"
      data-testid="inspection-list-item"
    >
      <Avatar
        alt={inspectionSteps[0].plate}
        src={inspectionSteps[0].photo.data}
        data-testid="avatar-photo"
      />
      <div style={{ fontSize: '14px' }}>{inspectionSteps[0].plate}</div>
      <div className="list-item__actions">
        {(editable && !isUploading) && (
          <>
            <IconButton
              onClick={goToEdit}
              data-testid="edit-button"
              aria-label="edit"
              size="large"
            >
              <EditOutlinedIcon fontSize="inherit" sx={{ color: '#3C3B3B' }} />
            </IconButton>
            <IconButton
              onClick={openDeleteDialog}
              aria-label="delete"
              size="large"
              data-testid="delete-button"
            >
              <DeleteOutlineIcon fontSize="inherit" sx={{ color: '#FF2323' }} />
            </IconButton>
          </>
        )}
        {(incomplete && !isUploading) && (
          <>
            <Button
              onClick={continueInspection}
              data-testid="continue-button"
              variant="outlined"
              size="small"
              sx={{
                textTransform: 'none',
                fontFamily: 'Poppins',
                fontSize: '13px',
                color: '#3C3B3B',
                borderColor: '#BFBEBE',
                borderRadius: '8px',
              }}
            >Continuar</Button>
            <IconButton
              onClick={openDeleteDialog}
              aria-label="delete"
              size="large"
              data-testid="delete-button"
            >
              <DeleteOutlineIcon fontSize="inherit" sx={{ color: '#FF2323' }} />
            </IconButton>
          </>
        )}
        {!editable && finished && (
          <CheckCircleIcon
            fontSize="large"
            sx={{ color: '#39B857' }}
            data-testid="finished-check"
          />
        )}
        {isUploading && (
          <LinearProgress
            sx={{ width: '60px' }}
            className="primary-progress"
          />
        )}
        {hasError && (
          <>
            <ErrorOutlineIcon
              fontSize="large"
              sx={{ color: '#FF2323' }}
              data-testid="finished-check"
              onClick={openVehicleError}
            />
             <IconButton
              onClick={openDeleteDialog}
              aria-label="delete"
              size="large"
              data-testid="delete-button"
            >
              <DeleteOutlineIcon fontSize="inherit" sx={{ color: '#FF2323' }} />
            </IconButton>
          </>
        )}
      </div>
    </Box>
  );
};

const mapStateToProps = (state: any) => ({
  ...state
});

const mapDispatchToProps = (dispatch: any) => ({
  plateAction: (payload: string) => dispatch(plateAction(payload)),
  uniqueInspectionIDAction: (payload: string) => dispatch(uniqueInspectionIDAction(payload)),
  appletProfileIdAction: (payload: string) => dispatch(appletProfileIdAction(payload)),
  vehicleDataAction: (payload: any) => dispatch(vehicleDataAction(payload)),
});


export default connect(mapStateToProps, mapDispatchToProps)(InspectionPanelListItem);
